import { render, staticRenderFns } from "./ChatLogItemDataCadastro.vue?vue&type=template&id=568c57df&"
import script from "./ChatLogItemDataCadastro.vue?vue&type=script&lang=js&"
export * from "./ChatLogItemDataCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports